module.exports = "/_next/static/images/laadpaal-3df58f985d2d934b915b7f454d1bc370.png";